var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopNavigationFavouriteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6973 4.0556C16.3072 3.66526 15.8439 3.35561 15.3341 3.14435C14.8242 2.93309 14.2777 2.82435 13.7258 2.82435C13.1739 2.82435 12.6274 2.93309 12.1176 3.14435C11.6077 3.35561 11.1444 3.66526 10.7543 4.0556L9.94456 4.86533L9.13484 4.0556C8.34674 3.26751 7.27785 2.82476 6.16331 2.82476C5.04877 2.82476 3.97988 3.26751 3.19178 4.0556C2.40369 4.8437 1.96094 5.91259 1.96094 7.02713C1.96094 8.14167 2.40369 9.21056 3.19178 9.99866L4.00151 10.8084L9.94456 16.7514L15.8876 10.8084L16.6973 9.99866C17.0877 9.6085 17.3973 9.14525 17.6086 8.63539C17.8199 8.12552 17.9286 7.57903 17.9286 7.02713C17.9286 6.47523 17.8199 5.92874 17.6086 5.41887C17.3973 4.90901 17.0877 4.44576 16.6973 4.0556V4.0556Z",
    stroke: "white",
    strokeWidth: 1.81424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopNavigationFavouriteIcon);
export default __webpack_public_path__ + "static/media/top-navigation-favourite-icon.786a5983012777e67d40d4847bc63a7e.svg";
export { ForwardRef as ReactComponent };